// extracted by mini-css-extract-plugin
export var calendarView = "_ni-0";